import React, { useState, useEffect, useContext, lazy, Suspense, useRef } from 'react';
import { Cookies } from '../../index.js';
import axios from 'axios';
import { alert_error, alert_success } from '../../AppContext';
import Login_google from '../../auth/login_google_main';
const App = () => {
    const [disabledbutton, setdisabledbutton] = useState(true);
    const [nutxuly, setnutxuly] = useState(0);
    const [buttonTextjop, setbuttonTextjop] = useState("Vui lòng tiếp tục bằng google 👌");
    return (
        <>
            <Login_google disabledbutton={disabledbutton} setdisabledbutton={setdisabledbutton}
                nutxuly={nutxuly} setnutxuly={setnutxuly}
                buttonTextjop={buttonTextjop} setbuttonTextjop={setbuttonTextjop}
            />
        </>
    );

};


export default App;